export default __webpack_public_path__ + "static/media/logo_wiki_side.f8ca5b90.svg";